module.exports = __webpack_public_path__ + "static/img/cloud-1.6389512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-1.png
// module id = KeZO
// module chunks = 0